
<script setup lang="ts">

import CustomButton from "@/components/Button/Button.vue";
import {useSearchStore} from "@/stores/searchStore";
import {onMounted} from "vue";
import {useDestinationStore} from "@/stores/destinationStore";



defineProps({
  openFilterModal: Boolean
});

const emit = defineEmits(["close"]);

const searchStore = useSearchStore();
const destinationStore = useDestinationStore();

onMounted(async() => {
  await destinationStore.getAllDestinations();
})


</script>

<template>


  <!-- Drawer -->
  <div
      class="fixed top-0 right-0 h-full bg-white z-50 p-5 pr-5 transition-transform duration-300 transform w-[350px] md:w-[95%] md:rounded-l-2xl flex flex-col"
      :class="openFilterModal ? 'translate-x-0' : 'translate-x-full'"
  >

    <!-- Header -->
    <div class="flex items-center justify-between py-4 flex-shrink-0">
      <span class="font-bold responsive-title-6">Filters</span>
      <button class="cursor-pointer border border-bw-grey py-1.5 px-4 rounded-full" @click="emit('close')">
        <img src="@/assets/icons/Close_16x16.svg" alt="close" width="16"/>
      </button>
    </div>


    <!-- Scrollable -->
    <div class="flex-grow overflow-y-auto pr-1">

      <div class="flex flex-col gap-6">
        <!-- Category -->
        <div>
          <h3 class="font-bold mb-2">Category</h3>
          <div class="flex flex-col gap-2">
            <label v-for="item in searchStore.categoryOptions" :key="item" class="flex items-center">
              <input
                  type="checkbox"
                  v-model="searchStore.categories"
                  :value="item"
                  class="mr-2 accent-primary-violet"
              />
              {{ item }}
            </label>
          </div>
        </div>

        <!-- Destination -->
<!--        <div>-->
<!--          <h3 class="font-bold mb-2">Destination</h3>-->
<!--          <div class="flex flex-col gap-2">-->
<!--            <label v-for="item in searchStore.destinationOptions" :key="item" class="flex items-center">-->
<!--              <input-->
<!--                  type="checkbox"-->
<!--                  v-model="searchStore.destinations"-->
<!--                  :value="item"-->
<!--                  class="mr-2 accent-primary-violet"-->
<!--              />-->
<!--              {{ item }}-->
<!--            </label>-->
<!--          </div>-->
<!--        </div>-->

        <!-- Length -->
        <div>
          <h3 class="font-bold mb-2">Length</h3>
          <div class="ml-3 ">
            <el-slider
                v-model="searchStore.length"
                range
                :min="searchStore.minLength"
                :max="searchStore.maxLength"
                show-tooltip
                show-stops
                tooltip-class="custom-slider-tooltip"
                class="custom-slider"
            />
          </div>
        </div>

        <!-- Guests -->
        <div class="max-h-[30px]">
          <h3 class="font-bold mb-2">Guests</h3>
          <el-input-number
              v-model="searchStore.guests"
              size="small"
              :min="1"
              class="custom-input-number"
          />
        </div>

        <!-- Price -->
        <div class="mt-8">
          <h3 class="font-bold mb-2">Price</h3>
          <div class="ml-3 ">
            <el-slider
                v-model="searchStore.price"
                range
                :min="searchStore.minPrice"
                :max="searchStore.maxPrice"
                show-tooltip
                tooltip-class="custom-slider-tooltip"
                class="custom-slider"
            />
          </div>
        </div>

      </div>

    </div>


    <!-- Footer -->
    <div class="flex justify-between flex-shrink-0 pt-3 px-8 bg-white border-t border-bw-grey">
      <button class="text-bw-midGrey font-semibold underline hover:text-primary-darkBlue" @click="searchStore.clearAllFilters">
        Clear
      </button>

      <CustomButton
          type="red"
          :rounded="true"
          :outlined="false"
          @click="emit('close')"
      >
        <span> Show ({{searchStore.filteredYachts.length}})</span>
      </CustomButton>
    </div>

  </div>


</template>


<style scoped>

:deep(.el-slider){
  width: 45% !important;
}



::v-deep(.custom-input-number .el-input__inner) {
  height: 28px;
  font-size: 15px;
  padding: 0 6px;
}

::v-deep(.custom-input-number .el-input-number__decrease),
::v-deep(.custom-input-number .el-input-number__increase) {
  height: 28px;
}

</style>
